import type { Token } from "marked";

enum TrailingOmitTokenType {
  HorizontalRule = "hr",
  Space = "space",
}

/**
 * Drop trailing thematic breaks (and surrounding space tokens) from a top-level
 * marked token list. Accordion bodies use this so a closing `---` does not stack
 * on the accordion row divider.
 */
export function omitTrailingHorizontalRuleTokens({
  tokens,
}: {
  tokens: Token[];
}): Token[] {
  let endIndex = tokens.length;

  const trimTrailingSpace = (): void => {
    while (
      endIndex > 0 &&
      tokens[endIndex - 1]?.type === TrailingOmitTokenType.Space
    ) {
      endIndex -= 1;
    }
  };

  trimTrailingSpace();

  let omittedRule = false;

  while (
    endIndex > 0 &&
    tokens[endIndex - 1]?.type === TrailingOmitTokenType.HorizontalRule
  ) {
    omittedRule = true;
    endIndex -= 1;
    trimTrailingSpace();
  }

  if (!omittedRule) {
    return tokens;
  }

  return tokens.slice(0, endIndex);
}
